"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelMixinInput = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _row = _interopRequireDefault(require("../row"));

var _col = _interopRequireDefault(require("../col"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// ShpmtcDesign Components
// Style
var PanelMixinInput = function PanelMixinInput(_ref) {
  var type = _ref.type,
      bottomBloc = _ref.bottomBloc,
      bottomBlocClass = _ref.bottomBlocClass,
      contentBloc = _ref.contentBloc;
  // Type
  var classname = '';

  switch (type) {
    case 'Simple':
      classname = 'panel-mixinInput--simple';
      break;

    default:
      classname = 'panel-mixinInput--default';
      break;
  }

  var bottomBlocObj = /*#__PURE__*/_react.default.createElement(_row.default, {
    gutter: 20,
    align: "top"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-mixinInput__bottom ".concat(bottomBlocClass)
  }, bottomBloc)));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-mixinInput ".concat(classname)
  }, contentBloc, bottomBloc != null ? bottomBlocObj : null);
}; // Prop Types


exports.PanelMixinInput = PanelMixinInput;
PanelMixinInput.defaultProps = {
  type: '',
  bottomBloc: null,
  bottomBlocClass: '',
  contentBloc: null
};
PanelMixinInput.propTypes = {
  type: _propTypes.default.string,
  bottomBloc: _propTypes.default.node,
  bottomBlocClass: _propTypes.default.string,
  contentBloc: _propTypes.default.instanceOf(Array)
};